import { useMutation } from "@tanstack/vue-query"
import { axios } from "@/axios"
import { EventVault } from "@/models"

interface ICreateEventProps {
  eventVault: EventVault
  paymentToken: string
  packageSubscriptionId?: string
  referrerId?: string
}
export async function createEventVault(eventVault: EventVault, paymentToken: string, packageSubscriptionId?: string, referrerId?: string) {
  const TEN_MINUTES_MS = 600000

  const params: { token: string, packageSubscriptionId?: string, referrerId?: string } = {
    token: paymentToken,
    packageSubscriptionId,
  }

  if (referrerId)
    params.referrerId = referrerId

  const response = await axios.postForm("/api/event", EventVault.toRequest(eventVault), {
    params,
    timeout: TEN_MINUTES_MS,
  })

  return EventVault.fromResponse(response.data.Data)
}

export function useCreateEventVault() {
  return useMutation({
    mutationKey: ["createEvent"],
    mutationFn: ({ eventVault, paymentToken, packageSubscriptionId, referrerId }: ICreateEventProps) => createEventVault(eventVault, paymentToken, packageSubscriptionId, referrerId),
  })
}
